import React, { useState } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import logo from '../../../assets/logo/marmin_logo.png';
import CustomTextInput from '../../../components/CustomTextInput';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { authApiClient } from '../../../utils/axios';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';

export const ForgotPasswordEmailSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email format').required('Email is required'),
});

const ForgotPasswordEmailForm = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    trigger,
    setError,
  } = useForm({
    resolver: yupResolver(ForgotPasswordEmailSchema),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    authApiClient
      .post('/generate-otp', data)
      .then((res) => {
        if (res.data.status.toLowerCase() === 'new') {
          setError('email', { message: 'No user found with this email!' });
        } else {
          navigate('/forgot-password', { replace: true, state: { email: data.email, stage: 'verification' } });
          dispatch(showSnackbar({ message: 'OTP sent successfully', severity: 'success' }));
        }
      })
      .catch((err) => {
        dispatch(
          showSnackbar({
            message: err?.response?.data?.errors?.message ?? 'Something went wrong.',
            severity: 'error',
          }),
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Stack sx={{ alignItems: 'center', mb: 4 }}>
        <img src={logo} alt="logo" width="50%" />
      </Stack>
      <Stack spacing={2}>
        <CustomTextInput name="email" label="Email" control={control} errors={errors} />
        <Button type="button" variant="contained" className="submit" onClick={handleSubmit(onSubmit)}>
          {loading ? 'Sending OTP...' : 'Send OTP'}
        </Button>
        <Typography variant="body2">
          <Link to="/login" style={{ textDecoration: 'none' }}>
            Back to Login
          </Link>
        </Typography>
      </Stack>
    </>
  );
};

export default ForgotPasswordEmailForm;
